import React from "react";

export default function Menu() {
  return (
    <div className="menuContainer primary white">
      <div className="menuExchange">SYMBOL</div>
      <div className="menuExchange">EXPIRY</div>
      <div className="menuExchange">BUY-QTY</div>
      <div className="menuExpiry">BUY-AVG</div>
      <div className="menuExpiry">SELL-QTY</div>
      <div className="menuBuyPrice">SELL-AVG</div>
      <div className="menuBuyQty">B-S:QTY</div>
      <div className="menuBuyQty">NET-QTY</div>
      <div className="menuSellPrice">LIVE RATE</div>
      <div className="menuClose">SELF M2M</div>
    </div>
  );
}
